import { render, staticRenderFns } from "./EditShareReport.vue?vue&type=template&id=2c9a46fa&scoped=true"
import script from "./EditShareReport.vue?vue&type=script&lang=js"
export * from "./EditShareReport.vue?vue&type=script&lang=js"
import style0 from "./EditShareReport.vue?vue&type=style&index=0&id=2c9a46fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a46fa",
  null
  
)

export default component.exports